import './Home.css';
import { Button, Card, Popover, Select, Flex } from 'antd';
import { IoMdAdd } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import GroupAvatar from '../../../Components/GroupAvatar/GroupAvatar';
import { LuKeyRound } from 'react-icons/lu';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { workspaces_List_ActionHandler } from '../../../Redux/Actions/user/WorkspacesList';
import CardSkeleton from '../../../Components/Skeleton/CardSkeloton';
import { WorkspaceAccessActionHandler } from '../../../Redux/Actions/user/WorkspaceAccessAction';
import { workpace_deleteAPI } from '../../../Redux/Apis/user/ApiConfig';

const Workspaces_icon = '/assets/workspace_Icon.svg';
const SearchIcon = '/assets/SearchIcon.svg';
const CubeIcon = '/assets/Cube_icon.svg';
const LockIcon = '/assets/lock.svg';
const dotIcon = '/assets/dot.svg';
const Option = { Select };

const Home = () => {
    const Navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState(null);
    const [itemToggleState, setItemToggleState] = useState({});
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data
    );

    const workspaceDataLoader = useSelector(
        (state) => state?.workspaces_List_Data?.loader
    );

    const userSlugData = useSelector(
        (state) => state.SettingsUserProfileData.slug
    );

    const workspaceaccessData = useSelector(
        (state) => state?.WorkspaceAccessData?.workspace_access_data
    );

    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', ''));
        localStorage.removeItem('activeTab');
    }, []);

    const formatDate = (timestamp) => {
        const dateObject = new Date(timestamp);

        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');
        const day = String(dateObject.getDate()).padStart(2, '0');
        let hours = dateObject.getHours();
        const minutes = String(dateObject.getMinutes()).padStart(2, '0');
        const seconds = String(dateObject.getSeconds()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12 || 12;

        const formattedDate = `${month}-${day}-${year}`;
        const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;

        return formattedDate + ' ' + formattedTime;
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handlesearch = debounce((e) => {
        let value = e.target.value.trim();
        if (value?.length) {
            setSearchValue(value);
        }

        if (!value.length) {
            dispatch(workspaces_List_ActionHandler('', ''));
        }
    }, 1000);

    const handleToggleActionBook = (e, itemId) => {
        e.stopPropagation();
        setItemToggleState((prevToggleState) => ({
            [itemId]: !prevToggleState[itemId],
        }));
    };

    useEffect(() => {
        if (searchValue?.length > 1) {
            dispatch(workspaces_List_ActionHandler(searchValue, ''));
        }
    }, [searchValue]);

    const handleSortChange = (sortvalue) => {
        dispatch(workspaces_List_ActionHandler('', sortvalue));
    };

    const handleWorkspaceAccessClick = (workspaceId) => {
        dispatch(WorkspaceAccessActionHandler(workspaceId));
    };

    const handleDelete = (e, Id) => {
        e.stopPropagation();
        setItemToggleState({});
        if (Id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this Workspace?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'Workspace has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    handleDeleteWorkspace(Id);
                }
            });
        }
    };

    const handleEdit = (e, item) => {
        e.stopPropagation();
        let navigateObj = {
            id: item.id,
        };
        const queryParams = new URLSearchParams(navigateObj).toString();
        const queryParamsObject = Object.fromEntries(
            new URLSearchParams(queryParams)
        );
        Navigate(`newWorkspaces/${queryParamsObject?.id}`);
    };

    const handleDeleteWorkspace = async (id) => {
        try {
            await workpace_deleteAPI(id);
            setItemToggleState({});
            window.location.reload();
        } catch (err) {}
    };

    return (
        <div className='workspace-container '>
            <div className='workspace-inner-main '>
                <h3>
                    <img src={Workspaces_icon} alt='' />
                    Workspaces ({workspaceData?.data?.length || 0})
                </h3>
                <div>
                    {/* {permissions && permissions[9]?.slug ? (
                        <button
                            className='active-roles-permissions permission-disabled'
                            disabled={true}>
                            <IoMdAdd />
                            Create New Workspaces
                        </button>
                    ) : ( */}
                    {userSlugData?.includes('add-new-workspace') ? (
                        <Button
                            className='main-api'
                            onClick={() => {
                                Navigate('/workspaces/newWorkspaces');

                                //gtm
                                window.dataLayer.push({
                                    event: 'Create workspaces',
                                    buttonName: ' Create New Workspaces',
                                    clientId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.client_id,
                                    userId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.id,
                                });
                            }}>
                            <IoMdAdd />
                            Create New Workspaces
                        </Button>
                    ) : null}
                </div>
            </div>
            <div className='workspace-input'>
                <div className='relative search-container'>
                    <input
                        type='text'
                        placeholder='Search workspace here'
                        className='search-from-logs'
                        onChange={(e) => handlesearch(e)}
                    />
                    <img src={SearchIcon} alt='' className='search-icon' />
                </div>
                <div>
                    <Select
                        defaultValue='Sort By'
                        className='select-sort-by'
                        onChange={handleSortChange}>
                        <Option value='name'> Name</Option>
                        <Option value='created_at'> Created At</Option>
                    </Select>
                </div>
            </div>

            {!workspaceDataLoader ? (
                <div className='grid-container'>
                    {workspaceData?.data?.length === 0 ? (
                        <div className='no-data-message'>
                            No such result found.
                        </div>
                    ) : (
                        workspaceData?.data?.map((item, index) => (
                            <Card
                                key={`workspace-card-${index}`}
                                className={
                                    item?.is_locked ? 'card-lock' : 'card-con'
                                }
                                onClick={() => {
                                    let obj = {
                                        name: item?.name,
                                        id: item?.id,
                                    };
                                    const queryParams = new URLSearchParams(
                                        obj
                                    ).toString();
                                    const queryParamsObject =
                                        Object.fromEntries(
                                            new URLSearchParams(queryParams)
                                        );
                                    if (!item?.is_locked) {
                                        window.dataLayer.push({
                                            event: 'workspaces',
                                            buttonName:
                                                'go to workspace ' + item?.name,
                                            clientId: JSON.parse(
                                                localStorage.getItem(
                                                    'userDetails'
                                                )
                                            )?.client_id,
                                            userId: JSON.parse(
                                                localStorage.getItem(
                                                    'userDetails'
                                                )
                                            )?.id,
                                        });

                                        Navigate(
                                            `/workspaces/${queryParamsObject.name}/${queryParamsObject.id}/details`
                                        );
                                    }
                                }}>
                                <div className='card'>
                                    <div className='card-content'>
                                        <div className='card-logo-content-div'>
                                            <img
                                                src={CubeIcon}
                                                className='card-logo'
                                                alt=''
                                            />
                                        </div>
                                        <Flex justify='flex-end'>
                                            <p className='card-content-date'>
                                                {item?.date}
                                            </p>
                                            {item?.is_locked ? (
                                                <Popover
                                                    content={
                                                        <div className='popover-lock-content'>
                                                            You do not have
                                                            access to this
                                                            workspace. To gain
                                                            access, please
                                                            request permission
                                                            from your
                                                            administrator.
                                                            <button
                                                                className='access-button'
                                                                onClick={() =>
                                                                    handleWorkspaceAccessClick(
                                                                        item.id
                                                                    )
                                                                }>
                                                                <LuKeyRound className='fakkey' />
                                                                <span className='button-text'>
                                                                    Request
                                                                    Access
                                                                </span>
                                                            </button>
                                                        </div>
                                                    }
                                                    trigger='click'
                                                    placement='bottom'>
                                                    <img
                                                        src={LockIcon}
                                                        alt=''
                                                        className='lock-icon'
                                                    />
                                                </Popover>
                                            ) : (
                                                <div className='dot-icon-wrapper'>
                                                    <div
                                                        className='recent-div-action recent-div-action-container'
                                                        onClick={(e) =>
                                                            handleToggleActionBook(
                                                                e,
                                                                item.id
                                                            )
                                                        }>
                                                        <img
                                                            src={dotIcon}
                                                            alt='dot icon'
                                                            className='vertical-img-logo'
                                                            height={20}
                                                            width={20}
                                                        />

                                                        <div
                                                            className={`workspace-dropup-form-content recent-form-header-availibility ${
                                                                itemToggleState[
                                                                    item.id
                                                                ]
                                                                    ? 'recent-workspace-droup-down-avail-details'
                                                                    : ''
                                                            }`}>
                                                            {item?.permissions?.includes(
                                                                'manage-workspace'
                                                            ) ? (
                                                                <div
                                                                    className='form-header-text'
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        handleEdit(
                                                                            e,
                                                                            item
                                                                        );
                                                                    }}>
                                                                    <span className='form-header-notifications-text'>
                                                                        Edit
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <div className='form-header-text permision-not-allowed-css '>
                                                                    <span className='form-header-notifications-text'>
                                                                        Edit
                                                                    </span>
                                                                </div>
                                                            )}

                                                            <div className='form-separator-header'></div>

                                                            {item?.permissions?.includes(
                                                                'delete-workspaces'
                                                            ) ? (
                                                                <div
                                                                    className='form-header-text'
                                                                    onClick={(
                                                                        e
                                                                    ) =>
                                                                        handleDelete(
                                                                            e,
                                                                            item.id
                                                                        )
                                                                    }>
                                                                    <span className='form-header-notifications-text form-text-color'>
                                                                        Delete
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <div className='form-header-text permision-not-allowed-css'>
                                                                    <span className='form-header-notifications-text form-text-color'>
                                                                        Delete
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Flex>
                                    </div>
                                    <Flex justify='space-between'>
                                        {/* <p className="card-name">{item?.name}</p> */}
                                        <p className='card-name'>
                                            {item?.name.length > 35
                                                ? `${item?.name.substring(
                                                      0,
                                                      35
                                                  )}...`
                                                : item?.name}
                                        </p>
                                    </Flex>
                                    <div className='card-content'>
                                        <div>
                                            <p className='card-content-date'>
                                                Total QA
                                            </p>
                                            <p className='card-name'>
                                                {item?.total_qa}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='card-content-date'>
                                                QA Credits remaining
                                            </p>
                                            <p className='reamaning_qa'>
                                                {item?.qa_credit_remaining}
                                            </p>
                                        </div>
                                    </div>
                                    <p className='team-members'>Team Members</p>
                                </div>
                                <div
                                    className={
                                        item?.isLock && 'avatar-group-div'
                                    }>
                                    <GroupAvatar
                                        maxCount={4}
                                        size=''
                                        otherMember={true}
                                        data={item?.team_members}
                                    />
                                </div>
                            </Card>
                        ))
                    )}
                </div>
            ) : (
                <CardSkeleton data={10} classname={''} />
            )}
        </div>
    );
};

export default Home;
